import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";

//componentes
import "./calificarTareas.css";
import Alert from "../../modal/alert";

class EvaluacionAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idmateria: "",
      idcurso: "",
      descripcionE: "",
      cantidadE: "",
      idplanEvaluacion: "",
      idprofesor: "",
      cedulaAlumno: "",
      fechaE: moment().format("YYYY-MM-DD"),
      nota: "",
      idplanE: "",
      anoEscolar: "",
      idtareas: "",
      trimestre: "",
      nombreEvaluacion: "",
      ianoEscolar: [],
      imaterias: [],
      icursos: [],
      imateriasA: [],
      iprofesor: [],
      ialumnos: [],
      ievaluaciones: [],
      idescripcionE: [],
      iactividades: [],
      listaOn: false,
      modificarOn: false,
      verplanillaOn: false,
    };
  }

  limpiar = () => {
    this.setState({
      idmateria: "",
      anoEscolar: "",
      idcurso: "",
      idprofesor: "",
      descripcionE: "",
      cantidadE: "",
      idplanEvaluacion: "",
      cedulaAlumno: "",
      fechaE: moment().format("YYYY-MM-DD"),
      nota: "",
      idplanE: "",
      idtareas: "",
      trimestre: "",
      nombreEvaluacion: "",
      ievaluaciones: [],
      listaOn: false,
      modificarOn: false,
    });
  };

  limpiar2(e) {
    this.setState({
      idmateria: "",
      idcurso: "",
      idprofesor: "",
      idplanE: "",
      cedulaAlumno: "",
      imaterias: [],
      icursos: [],
      ialumnos: [],
    });
  }

  onChange(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onChange2(e) {
    let index = e.target.getAttribute("id");
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });

    if (index === "trimestre") this.setState({ descripcionE: "" });
    if (index === "descripcionE") this.buscarPlanE(e.target.value);
    //if (index === "cccccc") this.buscarEvaluaciones(e.target.value);
  }

  onChange3 = (e) => {
    let idplane = e.target.value;
    let itemfind = this.state.imaterias.find((e) => e.variable1 === idplane);
    let index =
      typeof itemfind !== "undefined"
        ? this.state.imaterias.indexOf(itemfind)
        : 0;
    //console.log(index)
    let xcantidadE = this.state.imaterias[index].variable3;
    let xidmateria = this.state.imaterias[index].variable4;
    //console.log("cantidad: "+xcantidadE)
    //console.log("idmateria: "+xidmateria)
    this.consultarActividades(xidmateria);
    this.setState({
      [e.target.name]: e.target.value,
      cantidadE: xcantidadE,
      idmateria: xidmateria,
    });
  };
  consultar(e) {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("idmaestroE", e);
      data.append("boton", "buscarPlanEI");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/planEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              idcurso: res.data.variable3,
              idmateria: res.data.variable4,
              descripcionE: res.data.variable5,
              cantidadE: res.data.variable6,
              idplanEvaluacion: res.data.variable7,
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Plan Evaluacion.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    }
  }

  modificar = () => {
    if (this.state.idmateria.length > 0 && this.state.idcurso.length > 0) {
      let data = new FormData();
      data.append("idmaestroE", this.state.idplanEvaluacion);
      data.append("cantidad", this.state.cantidadE);
      data.append("descripcion", this.state.descripcionE);
      data.append("boton", "modificarPlanE");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/planEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.limpiar();
            this.buscarPlanE(this.state.idcurso);
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Plan de Evaluación.",
              cuerpoM: res.data.variable2,
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Plan de Evaluación.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Materias.",
        cuerpoM: "Debe seleccionar un Grado y una Materia.",
      });
    }
  };

  guardar = () => {
    if (this.state.nota > 0 && this.state.nota <= 5) {
      if (
        this.state.idmateria.length > 0 &&
        this.state.idplanE.length > 0 &&
        this.state.idcurso.length > 0 &&
        this.state.cedulaAlumno.length > 0 &&
        this.state.descripcionE.length > 0 &&
        this.state.trimestre.length > 0 &&
        this.state.nota.length > 0
      ) {
        let data = new FormData();
        data.append("cedulaAlumno", this.state.cedulaAlumno);
        data.append("idprofesor", this.state.idprofesor);
        data.append("idplanE", this.state.idplanE);
        data.append("idmateria", this.state.idmateria);
        data.append("idgrado", this.state.idcurso);
        data.append("idtituloNota", this.state.descripcionE);
        data.append("nota", this.state.nota);
        data.append("fecha", this.state.fechaE);
        data.append("cantidadE", this.state.cantidadE);
        data.append("idactividad", this.state.idtareas);
        data.append("anoEscolar", this.state.anoEscolar);
        data.append("trimestre", this.state.trimestre);
        data.append("nombreEvaluacion", this.state.nombreEvaluacion);

        data.append("boton", "guardarEvaluacion2");

        let config = {
          headers: {
            "Content-Type": "text/html",
          },
        };
        const xurl =
          "https://institutobilinguelasnaciones.com/prueba/backend/evaluacion.php";
        axios
          .post(xurl, data, config)

          .then((res) => {
            if (res.data.variable1) {
              //this.limpiar2();
              this.buscarEvaluaciones();
              this.setState({
                mensajealerta: true,
                tituloM: "Menu Asignar Notas.",
                cuerpoM: res.data.variable2,
              });
            } else {
              this.setState({
                mensajealerta: true,
                tituloM: "Menu Asignar Notas.",
                cuerpoM: res.data.variable2,
              });
            }
          });
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Asignar Materias.",
          cuerpoM: "Debe seleccionar un Grado y una Materia.",
        });
      }
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Notas.",
        cuerpoM: "El valor de la Nota debe estar entre 1 y 5.",
      });
    }
  };

  eliminar = (e) => {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("idmaestroE", e);
      data.append("boton", "eliminarPlanE");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/evaluacion.php";
      axios.post(xurl, data, config).then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Asignar Notas.",
            cuerpoM: res.data.variable2,
          });
          //this.limpiar();
          this.buscarEvaluaciones();
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Asignar Notas.",
            cuerpoM: res.data.variable2,
          });
        }
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Materias.",
        cuerpoM:
          "Debe existir un registro para poder eliminar la MAteria Asignada.",
      });
    }
  };

  buscarEvaluaciones2 = () => {
    if (
      this.props.cedulaAlumno.length > 0 &&
      this.props.idprofesor.length > 0 &&
      this.props.idmateria.length > 0 &&
      this.props.idcurso.length > 0
    ) {
      let data = new FormData();
      data.append("cedulaAlumno", this.props.cedulaAlumno);
      data.append("idprofesor", this.props.idprofesor);
      data.append("idmateria", this.props.idmateria);
      data.append("idgrado", this.props.idcurso);
      data.append("trimestre", this.props.trimestre);
      data.append("anoEscolar", this.props.anoEscolar);
      if (this.props.usuario1.nivel === "2") {
        data.append("idtareas", this.props.idtareas);
      }
      if (this.props.usuario1.nivel === "3") {
        data.append("idtareas", "");
      }
      data.append("boton", "buscarEvaluacionesX");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/evaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          let xievaluaciones = res.data.variable2;
          if (res.data.variable1) {
            this.setState({
              ievaluaciones: xievaluaciones,
              //modificarOn:true,
            });
          } else {
            this.setState({
              ievaluaciones: [],
              modificarOn: false,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Notas.",
        cuerpoM:
          "Debe Seleccionar un Profesor, Materia, Grado y Año Escolar gracias.",
      });
    }
  };

  //buscar notas
  buscarEvaluaciones = () => {
    if (
      this.state.cedulaAlumno.length > 0 &&
      this.state.idprofesor.length > 0 &&
      this.state.idcurso.length > 0
    ) {
      let data = new FormData();
      data.append("cedulaAlumno", this.state.cedulaAlumno);
      data.append("idprofesor", this.state.idprofesor);
      data.append("idplanE", this.state.idplanE);
      data.append("idmateria", this.state.idmateria);
      data.append("idgrado", this.state.idcurso);
      data.append("trimestre", this.state.trimestre);
      data.append("anoEscolar", this.state.anoEscolar);
      if (this.props.usuario1.nivel === "2") {
        data.append("idtareas", this.props.idtareas);
      }
      if (this.props.usuario1.nivel === "3") {
        data.append("idtareas", "");
      }

      data.append("boton", "buscarEvaluacionesX");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/evaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          let xievaluaciones = res.data.variable2;
          if (res.data.variable1) {
            this.setState({
              ievaluaciones: xievaluaciones,
              //modificarOn:true,
            });
          } else {
            this.setState({
              ievaluaciones: [],
              modificarOn: false,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Notas.",
        cuerpoM: "Debe Seleccionar un Profesor y un Grado, gracias.",
      });
    }
  };

  buscarCurso = (e) => {
    if (this.state.anoEscolar.length > 0) {
      if (e.length > 0) {
        let data = new FormData();
        data.append("idprofesor", e);
        data.append("boton", "buscarCurso");

        let config = {
          headers: {
            "Content-Type": "text/html",
          },
        };
        const xurl =
          "https://institutobilinguelasnaciones.com/prueba/backend/evaluacion.php";
        axios
          .post(xurl, data, config)

          .then((res) => {
            let xicursos = res.data.variable2;
            if (res.data.variable1) {
              this.setState({
                icursos: xicursos,
              });
            } else {
              this.setState({
                icursos: [],
              });
              if (res.data.variable3.length > 0) {
                this.setState({
                  mensajealerta: true,
                  tituloM: "Menu Asignar Notas.",
                  cuerpoM: res.data.variable3,
                });
              }
            }
          });
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Asignar Notas.",
          cuerpoM: "Debe Seleccionar un Profesor, gracias.",
        });
      }
    } else {
      this.setState({
        idprofesor: "",
        mensajealerta: true,
        tituloM: "Menu Asignar Notas.",
        cuerpoM: "Debe Seleccionar un Año Escolar, gracias.",
      });
    }
  };

  buscarPlanE = (e) => {
    let data = new FormData();
    data.append("idmateria", this.state.idmateria);
    data.append("idgrado", this.state.idcurso);
    data.append("trimestre", this.state.trimestre);
    data.append("iddescripcion", e);
    data.append("anoEscolar", this.state.anoEscolar);
    data.append("boton", "buscarMaestroE");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/evaluacion.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          cantidadE: res.data.variable2,
          idplanE: res.data.variable3,
        });
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Asignar Notas.",
          cuerpoM: res.data.variable2,
        });
      }
    });
  };

  buscarSalones = () => {
    let data = new FormData();
    data.append("boton", "buscarSalones");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl = "https://institutobilinguelasnaciones.com/prueba/backend/materia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xicursos = res.data.variable2;

        this.setState({
          icursos: xicursos,
        });
      });
  };

  buscarMaterias = () => {
    let data = new FormData();
    data.append("boton", "buscarMaterias");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl = "https://institutobilinguelasnaciones.com/prueba/backend/materia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let ximaterias = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            imaterias: ximaterias,
          });
        } else {
          this.setState({
            imaterias: [],
          });
        }
      });
  };

  buscarProfesor = () => {
    let form = new FormData();
    form.append("clave", this.props.usuario1.password);
    form.append("boton", "buscarPersonal3");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl = "https://institutobilinguelasnaciones.com/prueba/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      let xiprofesor = res.data.variable1;
      this.setState({
        iprofesor: xiprofesor,
      });
    });
  };

  buscarAnioEscolar = () => {
    let data = new FormData();
    data.append("boton", "buscarAnioEscolar");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/maternal.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          //anoEscolar: res.data.variable2,
          ianoEscolar: res.data.variable3,
        });
      }
    });
  };

  buscarDE = () => {
    let data = new FormData();
    data.append("boton", "buscarDE");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/descripcionEva.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xidescripcionE = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            idescripcionE: xidescripcionE,
          });
        } else {
          this.setState({
            idescripcionE: [],
          });
        }
      });
  };

  consultarActividades(e) {
    let data = new FormData();
    data.append("idprofesor", this.state.idprofesor);
    data.append("idgrado", this.state.idcurso);
    data.append("idmateria", e);
    data.append("anoEscolar", this.state.anoEscolar);
    data.append("boton", "buscarActividadesEvaluacion");

    axios({
      method: "post",
      url: "https://institutobilinguelasnaciones.com/prueba/backend/actividades.php",
      data: data,
    }).then((res) => {
      let xiactividades = res.data.variable2;
      this.setState({
        iactividades: xiactividades,
      });
    });
  }
  iniciarVariables = () => {
    this.setState({
      idprofesor: this.props.idprofesor,
      idmateria: this.props.idmateria,
      idcurso: this.props.idcurso,
      idtareas: this.props.idtareas,
      anoEscolar: this.props.anoEscolar,
      cedulaAlumno: this.props.cedulaAlumno,
      nombreEvaluacion: this.props.nombreEvaluacion,
    });
    this.buscarEvaluaciones2();
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  componentDidMount() {
    this.iniciarVariables();
    this.buscarDE();
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxcE col-12">
          <div className="titulo-cxc ">
            <p>ASIGNAR NOTAS A EL ESTUDIANTE: {this.props.nombreAlumno} </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          <div className="cont-listmedi row">
            <div className="cont-personal col-12">
              {this.props.usuario1.nivel === "3" && (
                <div className="contenedorcedula1 col-3">
                  <select
                    id="trimestre"
                    name="trimestre"
                    value={this.state.trimestre}
                    onChange={this.onChange2.bind(this)}
                  >
                    <option>-- Seleccionar Trimestre --</option>
                    <option value="1">1ER. TRIMESTRE</option>
                    <option value="2">2DO. TRIMESTRE</option>
                    <option value="3">3ER. TRIMESTRE</option>
                  </select>
                </div>
              )}
              {this.props.usuario1.nivel === "3" && (
                <div className="contenedorcedula1 col-3">
                  <select
                    id="descripcionE"
                    name="descripcionE"
                    value={this.state.descripcionE}
                    onChange={this.onChange2.bind(this)}
                  >
                    <option>-- Tipo/Evaluación --</option>
                    {this.state.idescripcionE.map((item, i) => {
                      return (
                        <option key={i} value={item.variable1}>
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}
              {this.props.usuario1.nivel === "3" && (
                <div className="contenedorcedula1 col-1">
                  <input
                    className="form-control"
                    type="text"
                    name="nota"
                    id="nota"
                    autoComplete="off"
                    placeholder="Nota"
                    maxLength="4"
                    onChange={this.onChange.bind(this)}
                    value={this.state.nota.toUpperCase()}
                  />
                </div>
              )}
              {this.props.usuario1.nivel === "3" && (
                <div className="contenedorcedula1 col-2">
                  <input
                    className="form-control"
                    type="date"
                    name="fechaE"
                    id="fechaE"
                    autoComplete="off"
                    onChange={this.onChange.bind(this)}
                    value={this.state.fechaE.toUpperCase()}
                  />
                </div>
              )}
              <div className="xcontenedorcedula1x col-3">
                {this.props.usuario1.nivel === "3" && (
                  <button
                    id="agregar"
                    className={this.state.modificarOn ? "botonOf" : "boton"}
                    onClick={
                      this.state.modificarOn ? "" : this.guardar.bind(this)
                    }
                  >
                    Agregar
                  </button>
                )}
                <button
                  id="salir"
                  className="boton"
                  onClick={() => {
                    this.props.handleClose();
                  }}
                >
                  Salir
                </button>
              </div>
            </div>
          </div>

          <div className="cont-listmedix row">
            <div className="listcxcxE col-12">
              <table className="tablacxcx" border="1">
                <thead>
                  <tr>
                    <th className="titucxc3">MATERIA</th>
                    <th className="titucxc3">PROFESOR</th>
                    <th className="titucxc1">DESCRIPCION DE EVALUACION</th>
                    <th className="titucxc5">FECHA</th>
                    <th className="titucxc5">NOTA.</th>
                    <th className="titucxc3xpe">
                      <span className="titulo-eliminar">
                        <span className="cerrarme3"></span>
                      </span>
                    </th>
                  </tr>
                </thead>

                {this.state.ievaluaciones.map((item, i) => {
                  return (
                    <tr
                      className={i % 2 === 0 ? "odd" : "odd"}
                      key={item.variable1}
                      id="tabla"
                    >
                      <td className="totalescxcx">{item.variable2}</td>
                      <td className="totalescxcx">{item.variable3}</td>
                      <td className="totalescxcx">
                        {item.variable4 + "-" + item.variable8}
                      </td>
                      <td className="totalescxcx">{item.variable5}</td>
                      <td className="totalescxcx">{item.variable6}</td>
                      <td className="xcerr">
                        {item.variable7 !== "SI" ? (
                          <span
                            className="cerrarme1"
                            onClick={this.eliminar.bind(this, item.variable1)}
                          ></span>
                        ) : (
                          <span className="cerrarme11"></span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(EvaluacionAction);
